import React from 'react';
import './EnConstruccion.css';

const EnConstruccion = () => {
  return (
    <div className="construccion-container">
      <div className="construccion-content">
        <img 
          src="/logo-rv-azul.png" 
          alt="Logo RV" 
          className="construccion-logo"
        />
        
        <div className="construccion-icon">
          🚧
        </div>
        
        <h1 className="construccion-title">
          Página en Construcción
        </h1>
        
        <p className="construccion-subtitle">
          Estamos trabajando para traerte algo increíble
        </p>
        
        <p className="construccion-footer">
          Pronto estará disponible
        </p>
      </div>
    </div>
  );
};

export default EnConstruccion;

